import React, { Component } from "react";
import { connect } from "react-redux";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  updateCurrentMenu,
  updateGoBackFromCustomerPageModalVisibility
} from "../../../actions/menu";
import {
  resetCustomerProfileForm,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile
} from "../../../actions/customerProfile";
import { Modal } from "semantic-ui-react";
import { saveCustomerDataHandler } from "../saveCustomerDataHandler";

@connect(mapStateToProps)
export default class GoBackFromCustomerPageModal extends Component {
  constructor(props) {
    super(props);
  }

  goBackHandler = () => {
    let { locationToGoToFromCustomerPageModal } = this.props;
    this.closeModal();
    this.props.dispatch(updateCurrentMenu(locationToGoToFromCustomerPageModal));

    this.props.dispatch(updateGlobalErrorMessage(""));
  };

  closeAndSave = () => {
    let { customerProfileData, apiCustomerProfileData } = this.props;

    let cb = () => {
      this.props.dispatch(
        updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile(true)
      );
      setTimeout(() => {
        this.goBackHandler();
      }, 0); // this is required because the cb is not called after the customer has been updated in the app state, but rather, before that, so we wait until the next JS app cycle
    };

    saveCustomerDataHandler(
      customerProfileData,
      apiCustomerProfileData,
      this.props.dispatch,
      cb
    );
  };

  resetCustomerProfileForm = () => {
    this.props.dispatch(resetCustomerProfileForm());
  };

  closeModal = () => {
    let visible = false;
    this.props.dispatch(updateGoBackFromCustomerPageModalVisibility(visible));
  };

  render() {
    let {
      goBackFromCustomerPageModalVisible,
      loadingCustomerProfile
    } = this.props;
    let {
      No,
      Yes,
      Ok,
      SaveChangesCloseModal,
      DiscardChanges
    } = window.APP.LANGUAGE.Shared.PopupWindows;

    if (!goBackFromCustomerPageModalVisible) {
      return "";
    }

    let discardChangesAndGoBack = () => {
      this.goBackHandler();
      setTimeout(() => {
        this.resetCustomerProfileForm();
      }, 0);
    };

    let saveButtonClasses = "ui button savebtn";
    let discardButtonClasses = "ui button cancel-btn";

    if (loadingCustomerProfile) {
      saveButtonClasses += " loading";
      discardButtonClasses += " disabled";
    }

    let modalContent = "";
    let canWeActuallySave = true;
    if (window.validMeReact) {
      try {
        canWeActuallySave = !window.validMeReact.validMeManager.areThereErrors(
          "customerProfileNames&customerProfile&customerProfileContacts"
        );
      } catch (ex) {}
    }

    if (canWeActuallySave) {
      modalContent = (
        <div className="save-box">
          <section className="header">
            {window.APP.LANGUAGE.Pages.CustomerProfile.SaveChanges}
            <button
              type="button"
              className="close_button"
              onClick={this.closeModal}
            ></button>
          </section>
          <section className="save_box_buttons">
            <div
              className={discardButtonClasses}
              onClick={discardChangesAndGoBack}
            >
              {No}
            </div>
            <div className={saveButtonClasses} onClick={this.closeAndSave}>
              {Yes}
            </div>
          </section>
        </div>
      );
    } else {
      modalContent = (
        <div className="save-box">
          <section className="header">
            {DiscardChanges}
            <button
              type="button"
              className="close_button"
              onClick={this.closeModal}
            ></button>
          </section>
          <section className="save_box_buttons">
            <div
              className={discardButtonClasses + " discard-button"}
              onClick={discardChangesAndGoBack}
            >
              {Ok}
            </div>
          </section>
        </div>
      );
    }

    return (
      <Modal
        className="bookingdetails-model go-back-from-customer-page-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          {modalContent}
        </Modal.Content>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    goBackFromCustomerPageModalVisible:
      state.menuReducer.goBackFromCustomerPageModalVisible,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    locationToGoToFromCustomerPageModal:
      state.menuReducer.locationToGoToFromCustomerPageModal
  };
}
